module.exports = __webpack_public_path__ + "img/mind_background_8_th.7af12076.png";